"use strict";

export function pad(num: number | string, size: number): string {
  let s = num+"";
  while (s.length < size) s = "0" + s;
  return s;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function copyArrayJson(item: any): any{
  return JSON.parse( JSON.stringify(item) );
}

export function timeTruncSecond(time: string): string{
  const slots = time.split(":");

  return slots[0]+":"+slots[1];
}

export function timestampStringToDate(stringDate: string ): Date{
  const datesparts: string[] = stringDate.split(" ");
  const dates: string[] = datesparts[0].split("-");
  const date = new Date();
  date.setFullYear(parseInt(dates[0]));
  date.setMonth(parseInt(dates[1])-1);
  date.setDate(parseInt(dates[2]));

  const times: string[] = datesparts[1].split(":");
  date.setHours(parseInt(times[0]));
  date.setMinutes(parseInt(times[1]));
  if(times.length == 3)
  date.setSeconds(parseInt(times[2]));

  return date;
}

export function dateStringToDate(stringDate: string ): number{
  const dates: string[] = stringDate.split("-");
  const date = new Date();
  date.setFullYear(parseInt(dates[0]));
  date.setMonth(parseInt(dates[1])-1);
  date.setDate(parseInt(dates[2]));
  return date.getTime();
}

export function dateStringToDateDate(stringDate: string ): Date{
  const dates: string[] = stringDate.split("-");
  const date = new Date();
  date.setFullYear(parseInt(dates[0]));
  date.setMonth(parseInt(dates[1])-1);
  date.setDate(parseInt(dates[2]));
  return date;
}


export function timeStringToTime(stringTime: string ): number{
  const times: string[] = stringTime.split(":");
  const time = new Date();
  time.setHours(parseInt(times[0]));
  time.setMinutes(parseInt(times[1]));
  if(times.length == 3)
    time.setSeconds(parseInt(times[2]));
  return time.getTime();
}

export function timeStringToDate(stringTime: string ): Date{
  const times: string[] = stringTime.split(":");
  const time = new Date();
  time.setHours(parseInt(times[0]));
  time.setMinutes(parseInt(times[1]));
  if(times.length == 3)
    time.setSeconds(parseInt(times[2]));
  return time;
}

export function nl2br (str: string, is_xhtml: boolean): string {
  // *     example 1: nl2br('Kevin\nvan\nZonneveld');
  // *     returns 1: 'Kevin<br />\nvan<br />\nZonneveld'
  // *     example 2: nl2br("\nOne\nTwo\n\nThree\n", false);
  // *     returns 2: '<br>\nOne<br>\nTwo<br>\n<br>\nThree<br>\n'
  // *     example 3: nl2br("\nOne\nTwo\n\nThree\n", true);
  // *     returns 3: '<br />\nOne<br />\nTwo<br />\n<br />\nThree<br />\n'
  const breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br ' + '/>' : '<br>'; // Adjust comment to avoid issue on phpjs.org display

  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

function ReplaceAll(target: string, search: string, replacement: string): string {
  return target.replace(new RegExp(search, 'g'), replacement);
}

export function GenerateFriendlyName(value: string): string {
  value = ReplaceAll(value, "Ã", "a")
	value = ReplaceAll(value, "á", "a")
	value = ReplaceAll(value, "ã", "a")
	value = ReplaceAll(value, "Á", "a")
	value = ReplaceAll(value, "à", "a")
	value = ReplaceAll(value, "À", "a")
	value = ReplaceAll(value, "â", "a")
	value = ReplaceAll(value, "Â", "a")

	value = ReplaceAll(value, "ç", "c")
	value = ReplaceAll(value, "Ç", "c")

	value = ReplaceAll(value, "õ", "o")
	value = ReplaceAll(value, "Õ", "o")
	value = ReplaceAll(value, "ó", "o")
	value = ReplaceAll(value, "Ó", "o")

	value = ReplaceAll(value, "é", "e")
	value = ReplaceAll(value, "É", "e")
	value = ReplaceAll(value, "ê", "e")
	value = ReplaceAll(value, "Ê", "e")

	value = ReplaceAll(value, "í", "i")
	value = ReplaceAll(value, "Í", "i")

	value = ReplaceAll(value, "ú", "u")
	value = ReplaceAll(value, "Ú", "u")

	value = ReplaceAll(value, "ñ", "n")
	value = ReplaceAll(value, "Ñ", "n")

	value = ReplaceAll(value, "_", "-")

	value = value.toLowerCase();
  //eslint-disable-next-line
  value = value.replace(new RegExp(/[^a-z0-9\s-]/,'g'), "");
  //eslint-disable-next-line
  value = value.replace(new RegExp(/[\s-]+/,'g'), " ");
  
  value = value.trim();
  //eslint-disable-next-line
  value = value.replace(new RegExp(/\s/,'g'), "-");

	return value
}

// CHECK LEVELS
export function checkAdmin(level: number): boolean{
  return level <= 1 ? true : false;
}
export function checkRecepcao(level: number): boolean{
  return checkAdmin(level) || level == 3 ? true : false;
}
export function checkDoc(level: number): boolean{
  // console.log("level", level)
  return checkAdmin(level) || level == 2 ? true : false;
}

export function checkTerapeuta(level: number): boolean{
  // console.log("level", level)
  return checkAdmin(level) || level == 4 || level == 5 ? true : false;
}

